// extracted by mini-css-extract-plugin
export default {"container":"Switch_container__l1i4M","input":"Switch_input__FW16U","label":"Switch_label__DP+0P","error":"Switch_error__Gq75q"};